module.exports = __webpack_public_path__ + "img/logo.bdf75ed7.png";